import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { ENDPOINTS } from "./endpoints";
import { servicesUtils } from "./utils/services.utils";
import { infoFetchGetNivelI, makeNivel } from "dtos/nivel";

export const getNivelesPaginado = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetNivelI>
  >({
    method: "GET",
    uri: ENDPOINTS.NIVELES_PAGINADO,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  const elementosFormated = response.elementos.map((ctElemento) =>
    makeNivel(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};
export const getNiveles = async (params: any) => {
  const response = await sendRequest<infoFetchGetNivelI[]>({
    method: "GET",
    uri: ENDPOINTS.NIVELES,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  // return elementos.map((ct) => makeNivel(ct));

  const elementosFormated = response.map((ctElemento) => makeNivel(ctElemento));
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const postNiveles = async ({ params }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetNivelI>({
    method: "POST",
    uri: ENDPOINTS.NIVELES,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeNivel(response);
};

export const putNiveles = async ({ params }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetNivelI>({
    method: "PUT",
    uri: ENDPOINTS.NIVELES,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeNivel(response);
};

export const deleteNiveles = async (id: any) => {
  const response = await sendRequest<infoFetchGetNivelI>({
    method: "DELETE",
    uri: ENDPOINTS.NIVELES + "/" + id,
  });
  return makeNivel(response);
};
